
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icon path issue with webpack
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

@Component({})
export default class CardMapStations extends Vue {
  @Prop({ required: true }) stations!: any[];

  private map: L.Map | null = null;
  private markers: L.Marker[] = [];

  get hasCoordinates(): boolean {
    return this.stations.some(
      (s) => s.latitude != null && s.longitude != null
    );
  }

  get stationsWithCoords(): any[] {
    return this.stations.filter(
      (s) => s.latitude != null && s.longitude != null
    );
  }

  mounted(): void {
    if (this.hasCoordinates) {
      this.$nextTick(() => this.initMap());
    }
  }

  beforeDestroy(): void {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  @Watch("stations")
  onStationsChange(): void {
    if (this.hasCoordinates) {
      if (!this.map) {
        this.$nextTick(() => this.initMap());
      } else {
        this.refreshMarkers();
      }
    }
  }

  private initMap(): void {
    const container = document.getElementById("map-stations-container");
    if (!container) return;

    this.map = L.map(container, {
      center: [46.5, 2.5],
      zoom: 6,
      zoomControl: true,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(this.map);

    this.refreshMarkers();
  }

  private refreshMarkers(): void {
    if (!this.map) return;

    this.markers.forEach((m) => m.remove());
    this.markers = [];

    const bounds: L.LatLngTuple[] = [];

    this.stationsWithCoords.forEach((station) => {
      const lat = parseFloat(station.latitude);
      const lon = parseFloat(station.longitude);
      const hasRupture = !!station.rupture;

      const icon = L.divIcon({
        className: "",
        html: `<div class="map-marker ${hasRupture ? "map-marker--rupture" : "map-marker--ok"}">
                 <span class="fal fa-gas-pump"></span>
               </div>`,
        iconSize: [36, 36],
        iconAnchor: [18, 36],
        popupAnchor: [0, -36],
      });

      const popup = L.popup({ maxWidth: 300 }).setContent(
        this.buildPopupContent(station)
      );

      const marker = L.marker([lat, lon], { icon })
        .bindPopup(popup)
        .addTo(this.map!);

      this.markers.push(marker);
      bounds.push([lat, lon]);
    });

    if (bounds.length > 0 && this.map) {
      this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 13 });
    }
  }

  private buildPopupContent(station: any): string {
    const disponible = station.disponible || "Aucune";
    const rupture = station.rupture || "Aucune";
    const miseajour = dayjs(station.miseajour).format("DD/MM/YYYY HH:mm");
    return `
      <div class="map-popup">
        <h4 class="map-popup__title">${station.brand} — ${station.nom}</h4>
        <p class="map-popup__address">${station.adresse} ${station.cp} ${station.ville}</p>
        <hr class="map-popup__hr" />
        <div class="map-popup__row">
          <div>
            <p class="map-popup__label">Disponibilité</p>
            <p class="map-popup__value">${disponible}</p>
          </div>
          <div>
            <p class="map-popup__label">Rupture</p>
            <p class="map-popup__value ${rupture !== "Aucune" ? "map-popup__value--rupture" : ""}">${rupture}</p>
          </div>
        </div>
        <hr class="map-popup__hr" />
        <p class="map-popup__label">Mise à jour : ${miseajour}</p>
      </div>
    `;
  }
}
